import React from 'react';
import SignupForm from './SignupForm';
import styles from './LoginPage.module.css';

const SignupPage: React.FC = () => {
  return (
    <div className={styles.loginPage}>
      <div className={styles.background}>
        <div className={styles.overlay}></div>
      </div>
      <div className={styles.content}>
        <SignupForm />
      </div>
    </div>
  );
};

export default SignupPage;
